export default __webpack_public_path__ + "static/media/Satyajit Pattanaik.6759a601.JPG";